import { PARTICIPANT_HOME_PATH } from "../consts/participantHomePath";

export const buildBreadcrumbNavigationConfig = (title, path = "") => ({
  title,
  path: `${PARTICIPANT_HOME_PATH}${path}`,
});
